import moment from "moment";


const AsyncStorage = async (transactions) => {

    var chain = 'wallets=' + JSON.stringify(transactions);
    const res =  await fetch(window.rv_reservie_address + "api/ajax-push-cart", {
        method: "POST",
        body: chain,
        credentials: 'include',
        mode: "cors",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-Requested-With": 'XMLHttpRequest',
            "X_REQUESTED_WITH": 'xmlhttprequest'
        }
    });

    const json = await res.json();

    return json;
    
}



const StorageRepeater = (transactions) => {

    var chain = 'wallets=' + JSON.stringify(transactions);
    const res =  fetch(window.rv_reservie_address + "api/ajax-push-cart", {
        method: "POST",
        body: chain,
        credentials: 'include',
        mode: "cors",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "X-Requested-With": 'XMLHttpRequest',
            "X_REQUESTED_WITH": 'xmlhttprequest'
        }
    }).then( res => {
        return res.json;
    });
}


function sessionSet( what, s )
{    
    if ( window.location !== window.parent.location ) {
        // The page is in an iframe
        window.parent.postMessage({'message':'rvCart', 'value': s}, '*');
    } else {
        // The page is not in an iframe
        
    }


    try{
        if (typeof sessionStorage !== "undefined")
            sessionStorage.setItem(what, s);
    }
    catch(e)
    {
        /* do nothing */
    }
    return
}


const Storage = (transactions) =>{
    const hash = btoa(encodeURIComponent(window.location.hostname));
    const t = filter(transactions);
    sessionSet(hash, JSON.stringify(t));
   // StorageRepeater(transactions);
}


export const filter = (  transactions ) => {

    transactions.card = transactions.card.map( transaction =>{
        transaction.objects = transaction.objects.filter( item => {
            const d   = moment(item.date + " " + item.time); 
            return moment().isBefore(d);
        });
        return transaction;
    })

    transactions.pass = transactions.pass.map( pass => {
        pass.transactions = pass.transactions.map( transaction =>{
            
            
            transaction.objects = transaction.objects.filter( item => {
                const d   = moment(item.date + " " + item.time); 
                return moment().isBefore(d);
            });
            return transaction;           
        });
        return pass;
    }); 

    return transactions;
}

export const CartControllerReducer = (state, action) => {

    
    switch (action.type) {

        case "INITIALIZE_CART":
        {
            state.wallets = action.payload; 
            state.initialized = true;           
            return {
                ...state,
                ... Storage(state.wallets)

            } 
                       
        }
        break;

        case "PUSH_EVENT":
        {        
            state.event.push( action.payload );
            return {
                ...state
            }                
        }
        break;

        case "POP_EVENT":
        {
            // pop off the head 
            //console.log("Popping event", state.event);
            state.event = state.event.filter( (event, index) => index === 0? false: true);
            if(state.queue.length > 0)
            {
                state.event = state.queue.filter( (event, index) => index === 0? true: false);
            }
            state.queue = state.queue.filter( (event, index) => index === 0? false: true);

            //console.log("Popped event", state.event);
            return {
                ...state
            }              
        }
        break;
       
        case "ATTACH_PASS_WALLET":
        {
            /* Transition cart item to stage 2 */

            var search = state.wallets.pass.findIndex( (item) => 
            {
                //console.log("is in wallet", item.id, action.payload.id);   
                return item.id === action.payload.id
            });


            //console.log("attached state wallett", search);
            if(search < 0)
            {
                /* now present - attach */
                //console.log("attaching to wallett", action.payload);
                state.wallets.pass.push(Object.assign({}, action.payload ));
                return {
                    ...state,
                    ... Storage(state.wallets)
                } 
            }
            else
            {
                state.wallets.pass[search].credits = action.payload.credits;
                state.wallets.pass[search].expires = action.payload.expires;
                return state;
            }
               
        }


        case "ATTACH_SUBSCRIPTION_WALLET":
        {
            /* Transition cart item to stage 2 */
            var search = state.wallets.subscription.findIndex( (item) => item.id === action.payload.id);
            if(search < 0)
            {
                /* now present - attach */
                state.wallets.subscription.push(Object.assign({}, action.payload ));
                return {
                    ...state,
                    ... Storage(state.wallets)
                } 
            }
            else
            {
                state.wallets.subscription[search].credits = action.payload.credits;
                state.wallets.subscription[search].expires = action.payload.expires;
                return state;
            }
               
        }


        case "SWITCH_PENDING_PASS_WALLET":
        {
            /* Transition cart item to stage 2 */
       
            /* now present - attach */
            state.wallets.pass = state.wallets.pass.map( pass => {
                if(pass.mode === 'pending')
                {
                    let p = Object.assign({}, pass);
                    p.mode = 'debit';
                    return p;
                }
                else
                {
                    return pass;
                }
            })
            return {
                ...state,
                ... Storage(state.wallets)
            }  
        }
        break;
        
        
        case "CLEAR_PENDING_PASS_WALLET":
            {
                /* Transition cart item to stage 2 */
           
                /* now present - attach */
                state.wallets.pass = state.wallets.pass.filter( pass => pass.mode !== 'pending');
                return {
                    ...state,
                    ... Storage(state.wallets)
                }
            }
            break;                  


        case "PUSH_OBJECT_TO_CARD_WALLET":
        {
            /* Transition cart item to stage 2 */

                state.wallets.card.push(Object.assign({}, action.payload));
                //state.event = null;
                return {
                    ...state,
                    ... Storage(state.wallets)
                }                
                
                
               
        } 
        break;


        case "POP_OBJECT_FROM_WALLET":
        {
            /* Transition cart item to stage 2 */
            const rcw = state.wallets.card.reverse();
            //console.log("start set", rcw);

            let index = rcw.findIndex( (transaction) => transaction.id === action.payload.key_1);
            if(index >= 0)
            {
                //console.log("deleting card index", index);
                state.wallets.card = rcw.filter((tx, i) => index !== i).reverse();
            }
            else
            {
                let found = false;
                for(var i = 0; i < state.wallets.pass.length && found === false; i++)
                {
                    const pcw = state.wallets.pass[i].transactions.reverse();
                    index = pcw.findIndex(transaction => {
                        //console.log("comparing", transaction.id,  action.payload.key_1);
                        return transaction.id === action.payload.key_1;
                    });

                    if(index >= 0)
                    {
                        state.wallets.pass[i].transactions =  pcw.filter((tx, i) => index !== i).reverse(); 
                        //console.log("splicing at ", index, state.wallets.pass[i].transactions);
                        found = true;                     
                    }
                }
            }

            //console.log("final set", state.wallets);
            
            //state.event = null;
            
            return {    
                ...state,
                ...Storage(state.wallets)
            }

            //console.log('ready to return');
                                    
        } 
        break;



        case "PUSH_OBJECT_TO_PASS_WALLET":
        {
            var search = state.wallets.pass.findIndex( (item) => item.id === action.payload.id);
            if(search >= 0)
            {
                //console.log('adding', action.payload.object);
                const o = action.payload.object;
                state.wallets.pass[search].transactions.push(o);
                return {
                    ...state,
                    ...Storage(state.wallets)
                }            
                
            }
            else
            {
                return state;
            }

              
        }
        break;

        case 'DETACH_PASS_WALLET':
        {
            state.wallets.pass = state.wallets.pass.filter( (item) => !(item.id === action.payload.id));
            return {
                ...state,
                ...Storage(state.wallets)
            }                        
        }


        case 'DETACH_SUBSCRIPTION_WALLET':
        {
            state.wallets.subscription = state.wallets.subscription.filter( (item) => !(item.id === action.payload.id));
            return {
                ...state,
                ...Storage(state.wallets)
            }                        
        }



        case 'DECREMENT_PASS_WALLET_EVENT_QTY':
        {

            state.wallets.pass =  state.wallets.pass.map( tx => {
                tx.transactions = tx.transactions.map( transaction => {
                    transaction.objects = transaction.objects.map( object => {
                        if(tx.id === action.payload.wallet_id && transaction.id === action.payload.id)
                        {
                            object.qty -= 1;
                        }
                        return object;
                    }).filter(object => object.qty > 0);
                    return transaction;
                }).filter( transaction => transaction.objects.length > 0);
                return tx;
            });

            return {
                ...state,
                ...Storage(state.wallets)
            }  
        }


        case 'INCREMENT_PASS_WALLET_EVENT_QTY':
        {
            state.wallets.pass =  state.wallets.pass.map( tx => {
                tx.transactions = tx.transactions.map( transaction => {
                    transaction.objects = transaction.objects.map( object => {
                        if(tx.id === action.payload.wallet_id && transaction.id === action.payload.id)
                        {
                            object.qty -= 1;
                        }
                        return object;
                    }).filter(object => object.qty > 0);
                    return transaction;
                }).filter( transaction => transaction.objects.length > 0);
                return tx;
            });

            return {
                ...state,
                ...Storage(state.wallets)
            }  
        }



        case 'DECREMENT_CARD_WALLET_EVENT_QTY':
        {

            state.wallets.card =  state.wallets.card.map( (transaction, idex) => {
                transaction.objects = transaction.objects.map( object => {
                    if((transaction.id === action.payload.id) && (idex === action.payload.instance))
                    {
                        object.qty -= 1;
                    }
                    return object;
                }).filter(object => object.qty > 0);
                return transaction;
            }).filter( transaction => transaction.objects.length > 0);
        
            return {
                ...state,
                ...Storage(state.wallets)
            }  
        }


        case 'INCREMENT_CARD_WALLET_EVENT_QTY':
        {
            state.wallets.card =  state.wallets.card.map( transaction => {
                transaction.objects = transaction.objects.map( object => {
                    if(transaction.id === action.payload.id)
                    {
                        object.qty += 1;
                    }
                    return object;
                }).filter(object => object.qty > 0);
                return transaction;
            }).filter( transaction => transaction.objects.length > 0);
        
            return {
                ...state,
                ...Storage(state.wallets)
            }  
        }


        default:
            return state

    }
}